<template lang="html">
  <div>
    <sidebar :version="version"/>
    <navbar/>
    <router-view/>
    <notifications group="zone" position="bottom right" classes="zone-notification"/>
  </div>
</template>

<script>
import Sidebar from "@/components/common/Sidebar";
import Navbar from "@/components/common/Navbar";
import UsersModel from "@/models/users";


export default {
  name: 'App',
  components: {Navbar, Sidebar},
  data() {
    return {
      version: "pobieranie informacji"
    }
  },
  methods: {
    getCurrentUser() {
      return UsersModel.getCurrentUser();
    }
  },
  mounted() {
    if ((this.$route.name == 'verify') || (this.$route.name == 'verifyfull'))
      return;
    this.getCurrentUser()
      .then((res) => {
        this.version = res.data.app_version;
        this.$store.commit("setCurrentUserData", res.data);
      })
      .catch(() => window.location.href = 'https://ceeb.gov.pl/');
  }
}
</script>

<style>
.version {
  position: absolute;
  right: 0;
  bottom: 0;
  padding: 0 2em;
}

.privacy-policy {
  position: fixed;
  right: 1rem;
  bottom: .1rem;
  color: #202f64;
}
</style>
